var MAUIMODES = /* @__PURE__ */ ((MAUIMODES2) => {
  MAUIMODES2["edit"] = "edit";
  MAUIMODES2["clone"] = "clone";
  MAUIMODES2["create"] = "create";
  return MAUIMODES2;
})(MAUIMODES || {});
var MAUIDraftEntityPaths = /* @__PURE__ */ ((MAUIDraftEntityPaths2) => {
  MAUIDraftEntityPaths2["metric"] = "metric";
  MAUIDraftEntityPaths2["column"] = "column";
  MAUIDraftEntityPaths2["segment"] = "segment";
  MAUIDraftEntityPaths2["template"] = "template";
  MAUIDraftEntityPaths2["enrichment"] = "enrichment";
  MAUIDraftEntityPaths2["analysis"] = "analysis";
  MAUIDraftEntityPaths2["scorecards"] = "scorecards";
  MAUIDraftEntityPaths2["scorecard"] = "scorecard";
  MAUIDraftEntityPaths2["preview"] = "preview";
  MAUIDraftEntityPaths2["analysis-template"] = "analysis-template";
  MAUIDraftEntityPaths2["configuration"] = "configuration";
  MAUIDraftEntityPaths2["metric-template"] = "metric-template";
  return MAUIDraftEntityPaths2;
})(MAUIDraftEntityPaths || {});
var MAUIEntityPaths = /* @__PURE__ */ ((MAUIEntityPaths2) => {
  MAUIEntityPaths2["metric"] = "metric";
  MAUIEntityPaths2["column"] = "column";
  MAUIEntityPaths2["segment"] = "segment";
  MAUIEntityPaths2["template"] = "template";
  MAUIEntityPaths2["enrichment"] = "enrichment";
  MAUIEntityPaths2["analysis"] = "analysis";
  MAUIEntityPaths2["scorecards"] = "scorecards";
  MAUIEntityPaths2["scorecard"] = "scorecard";
  MAUIEntityPaths2["preview"] = "preview";
  MAUIEntityPaths2["analysis-template"] = "analysis-template";
  MAUIEntityPaths2["configuration"] = "configuration";
  MAUIEntityPaths2["setup"] = "setup";
  return MAUIEntityPaths2;
})(MAUIEntityPaths || {});
var MAUIConfigurationPaths = /* @__PURE__ */ ((MAUIConfigurationPaths2) => {
  MAUIConfigurationPaths2["data-source"] = "data-source";
  MAUIConfigurationPaths2["aggregation-level"] = "aggregation-level";
  MAUIConfigurationPaths2["exp-setup"] = "exp-setup";
  MAUIConfigurationPaths2["git-repo-setup"] = "git-repo-setup";
  MAUIConfigurationPaths2["access-control-setup"] = "access-control-setup";
  MAUIConfigurationPaths2["analysis-defaults"] = "analysis-defaults";
  MAUIConfigurationPaths2["preview-scorecard-settings"] = "preview-scorecard-settings";
  return MAUIConfigurationPaths2;
})(MAUIConfigurationPaths || {});
var MAUIEnrichmentPaths = /* @__PURE__ */ ((MAUIEnrichmentPaths2) => {
  MAUIEnrichmentPaths2["Alerts"] = "Alerts";
  MAUIEnrichmentPaths2["SeedFinder"] = "SeedFinder";
  MAUIEnrichmentPaths2["TrafficFilterDimensionMap"] = "TrafficFilterDimensionMap";
  return MAUIEnrichmentPaths2;
})(MAUIEnrichmentPaths || {});
var SegmentLevel = /* @__PURE__ */ ((SegmentLevel2) => {
  SegmentLevel2["base"] = "base";
  SegmentLevel2["rand_unit"] = "rand_unit";
  return SegmentLevel2;
})(SegmentLevel || {});
export {
  MAUIConfigurationPaths,
  MAUIDraftEntityPaths,
  MAUIEnrichmentPaths,
  MAUIEntityPaths,
  MAUIMODES,
  SegmentLevel
};
//# sourceMappingURL=MAUI.models.js.map
